// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3ozLJ","rootSuccess":"CompleteLink_rootSuccess__237Np","rootFailure":"CompleteLink_rootFailure__15yPl","isDisabled":"CompleteLink_isDisabled__1m6Nr"};